import { all, fork } from 'redux-saga/effects';
import listenLoad from './listenLoad';

export default function* bookingCardSaga() {
  yield all([fork(listenLoad)]);
}
